import { createRouter, createWebHistory } from "vue-router";
import { Dashboard, Profile, ResetPassword, ForgotPassword, SignIn, ChangePassword, DataPipelineTransformation } from "../views/exporter.js"
import { SetStoreLoginedValues, LoggedIn } from "@/customFunctions/Auth.js";
import { SendGETServerAPI } from "@/customFunctions/Api.js";
import store from "@/store/index.js"



const routes = [
  {
    path: "/",
    name: "/",
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  {
    path: "/dashboard-default",
    name: "Dashboard",
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { requiresAuth: true }
  },
  {
    path: "/signin",
    name: "SignIn",
    component: SignIn,
    meta: { requiresAuth: false }
  },
  {
    path: "/signIn/:pathMatch(.*)*",
    name: "DefaultPage",
    component: SignIn,
    meta: { requiresAuth: false }
  },
  {
    path: "/forgotPassword",
    name: "Forgot Password",
    component: ForgotPassword,
    meta: { requiresAuth: false }
  }, {
    path: "/resetPassword",
    name: "Reset Password",
    component: ResetPassword,
    meta: { requiresAuth: false }
  }, {
    path: "/changePassword",
    name: "Change Password",
    component: ChangePassword,
    meta: { requiresAuth: false }
  },
  {
    path: "/dataPipelineTransformation/:pathMatch(.*)*",
    name: "DataPipeline Transformation",
    component: DataPipelineTransformation,
    meta: { requiresAuth: true }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

router.beforeEach(async (from, to, next) => {
  let needRedirect = false;
  if (from.fullPath.includes('redirect=')) {
    needRedirect = true;
  }

  if (!from.meta.requiresAuth && !needRedirect) {
    next();
    return;
  }

  const isAuthorized = store.getters.getIsLogined;
  if (isAuthorized) {
    if (needRedirect) {
      next({ name: 'Dashboard' })
      return;
    }
    next();
    return;
  }

  const loggedIn = await LoggedIn(store, this);
  if (loggedIn.isOk) {
    store.commit('setShowPreloader', true);
    const sendQueriesResponse = await SendQueries();
    SetValues(sendQueriesResponse);
    store.commit('setShowPreloader', false);
    const doesUrlIncludeDataTransformation = CheckIfRouteIncludeDataPipelineTransformationUrl(from);
    if (doesUrlIncludeDataTransformation) {
      to.params = { pageName: doesUrlIncludeDataTransformation }
    }

    next(from.fullPath)
    return
  }
  else {
    if (needRedirect) {
      next();
      return;
    }

    let localRedirect = false;
    routes.map(x => {
      if (from.fullPath === x.path && from.fullPath !== '/') {
        localRedirect = true
      }
    })

    if (localRedirect) {
      next(`/signIn/redirect=${from.fullPath.substring(1)}`)
    }
    next({ name: 'SignIn' })
  }
})

async function SendQueries() {
  const getApiRefreshToken = await SendGETServerAPI(
    "account/GetRefreshToken",
    {
      Authorization: "Bearer " + store.getters.getAccessToken,
    }
  );

  return { getApiRefreshToken };
};

function SetValues(obj) {
  SetStoreLoginedValues(store, true, router);
  store.commit('setApiRefreshTokenMutation', obj.getApiRefreshToken.RefreshTokenApi);
};

function CheckIfRouteIncludeDataPipelineTransformationUrl(from) {
  switch (true) {
    case include('Market'):
      return 'Market'
    case include('MarketSource'):
      return 'MarketSource'
    case include('Instrument'):
      return 'Instrument'
    case include('Dataset'):
      return 'Dataset'
      case include('InstrumentSource'):
      return 'InstrumentSource'
    default:
      return false;
  }

  function include(data) { return from.fullPath.toLowerCase().includes(data.toLowerCase()) }
}

export default router;
